export default "<div #animatedDigit class=\"animated-digit\">\n    <span>{{digit}}</span>\n  </div>\n  ";